import { render } from "./CallSessionsLogs.vue?vue&type=template&id=5cab6f89"
import script from "./CallSessionsLogs.vue?vue&type=script&lang=js"
export * from "./CallSessionsLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__